/* Waitlist forms post directly to Klaviyo's client subscription API.
   Nothing here depends on Klaviyo's onsite script or on cookie consent. */
(function () {
  var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';
  var REVISION = '2024-10-15';

  function say(form, text, isError) {
    var msg = form.querySelector('.ffkl-msg');
    if (!msg) return;
    msg.textContent = text;
    msg.hidden = false;
    msg.classList.toggle('is-error', !!isError);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form.ff-klform');
    if (!form) return;
    e.preventDefault();

    var field = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"]');
    var email = field ? field.value.trim() : '';

    if (!email || email.indexOf('@') < 1 || email.lastIndexOf('.') < email.indexOf('@')) {
      say(form, 'That email does not look right.', true);
      if (field) field.focus();
      return;
    }

    var original = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Joining';
    }

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: { signup_source: form.getAttribute('data-kl-source') || 'waitlist' }
              }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: form.getAttribute('data-kl-list') } }
        }
      }
    };

    fetch(ENDPOINT + '?company_id=' + encodeURIComponent(form.getAttribute('data-kl-key')), {
      method: 'POST',
      headers: { revision: REVISION, 'content-type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (res.status === 202 || res.ok) {
          form.classList.add('is-done');
          if (field) field.value = '';
          say(form, form.getAttribute('data-kl-success') || "You're on the list. Watch your inbox.", false);
          if (field) field.hidden = true;
          if (button) button.hidden = true;
          document.dispatchEvent(new CustomEvent('ff:waitlist-signup', { detail: { email: email } }));
        } else {
          say(form, 'Something went wrong. Try again in a moment.', true);
        }
      })
      .catch(function () {
        say(form, 'Something went wrong. Try again in a moment.', true);
      })
      .then(function () {
        if (button && !button.hidden) {
          button.disabled = false;
          button.textContent = original;
        }
      });
  });
})();
